import React from 'react';
import { useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import routes from '../../Utils/routes';
import { getAxiosInstance, getConfig } from '../../Utils/apiService';
import { useAppContext } from '../../Helpers/Contexts/appContext';
import KenLoader from '../../GlobalComponents/KenLoader';
import axios from 'axios';
import { KEY_AZURE_TOKEN } from '../../Helpers/constant';
import { ConfigOptions } from '../../interfaces/Common';
import AuthLayout from '../../Components/AuthLayout';
import AppLayout from '../../Components/AppLayout';
import { PrivateRoute, PublicRoute } from '../../Utils/helperFunctions';
import storage from '../../storageService';
import EditProfile from '../MyProfile/Components/PersonalDetails/Pages/EditProfile';
const Home = React.lazy(() => import('../../Containers/Home/index'))
const Signup = React.lazy(() => import('../Auth/SignUp/index'));
const VerifyOTP = React.lazy(() => import('../Auth/VerifyOtp/index'));
const EmailConformation = React.lazy(() => import('../Auth/ConfirmEmail/index'));
const Login = React.lazy(() => import('../Auth/Login/index'));
const ForgotPassword = React.lazy(() => import('../Auth/ForgotPassword/index'));
const ConfirmPassword = React.lazy(() => import('../Auth/ConfirmPassword/index'));
const Learn = React.lazy(() => import('../Learn/index'));
const StepperComponent = React.lazy(() => import("../Learn/StepperComponent"));
const Part1=React.lazy(()=>import("../Learn/part1"));
const Part2=React.lazy(()=>import("../Learn/part2"));
const Part3=React.lazy(()=>import("../Learn/part3"));
const Part4=React.lazy(()=>import("../Learn/Part4"));
const MainLayout: React.FunctionComponent = () => {
  const {
    dispatch,
    state: { config },
  } = useAppContext();

  const [forgotPassword, setForgotPassword] = useState(false);
  useEffect(() => {
    getConfig()
      .then((res: Array<ConfigOptions>) => {
        console.log('getConfig response:', res);
        dispatch({ type: 'updateConfig', value: res[0]?.config });
        dispatch({ type: 'updateLogo', value: res[0]?.config?.logoURL });
        getAxiosInstance(res);
        console.log('Passed to getAxiosInstance:', res);
        try {
          axios({ method: 'get', baseURL: res[0]?.config?.tokenUrl })
            .then((response: any) => {
              // localStorage.setItem(KEY_AZURE_TOKEN, response.data.access_token);
              storage.set(KEY_AZURE_TOKEN, response.data.access_token);
            })
            .catch((err) => {
              return err;
            });
        } catch (err) {
          console.error(err);
        }
      })
      .catch((err) => {
        console.error('error in config', err);
      });
  }, []);

  return config.apiBaseUrl === '' ? (
    <KenLoader />
  ) : (
    <>
      <Routes>
        {/* Initial Route */}
        <Route path="/" element={<Navigate to={routes.login} />} />
     

        {/* Public Routes */}
        <Route
          path={routes.login}
          index
          element={
            <PublicRoute>
              <AuthLayout>
                <Login />
              </AuthLayout>
            </PublicRoute>
          }
        />

        <Route
          path={routes.otpverification}
          element={
            <PublicRoute>
              <AuthLayout>
                <VerifyOTP />
              </AuthLayout>
            </PublicRoute>
          }
        />
        <Route
          path={routes.emailverification}
          element={
            <PublicRoute>
              <AuthLayout>
                <EmailConformation />
              </AuthLayout>
            </PublicRoute>
          }
        />
        <Route
          path={routes.forgotPassword}
          element={
            <PublicRoute>
              <AuthLayout>
                <ForgotPassword setForgotPassword={setForgotPassword} />
              </AuthLayout>
            </PublicRoute>
          }
        />
        <Route
          path={routes.signup}
          element={
            <PublicRoute>
              <AuthLayout>
                <Signup />
              </AuthLayout>
            </PublicRoute>
          }
        />
        <Route
          path={routes.changePassword}
          element={
            <PublicRoute>
              <AuthLayout>
                <ConfirmPassword />
              </AuthLayout>
            </PublicRoute>
          }
        />
        {/* home */}
        <Route
          path={routes.home}
          element={
            <PublicRoute>
              <AppLayout>
                <Home />
              </AppLayout>
            </PublicRoute>
          }
        />
              <Route
          path={routes.learn}
          element={
            <PublicRoute>
              <AppLayout>
                <Learn />
              </AppLayout>
            </PublicRoute>
          }
        />
           <Route
          path={routes.stepper}
          element={
            <PublicRoute>
              <AppLayout>
                <StepperComponent />
              </AppLayout>
            </PublicRoute>
          }
        />
        <Route
          path={routes.part1}
          element={
            <PublicRoute>
              <AppLayout>
                <Part1 />
              </AppLayout>
            </PublicRoute>
          }
        />
 <Route
          path={routes.part2}
          element={
            <PublicRoute>
              <AppLayout>
                <Part2 />
              </AppLayout>
            </PublicRoute>
          }
        />
        
       
      
        <Route
          path={routes.part3}
          element={
            <PublicRoute>
              <AppLayout>
                <Part3 />
              </AppLayout>
            </PublicRoute>
          }
        />

      
        
<Route
          path={routes.part4}
          element={
            <PublicRoute>
              <AppLayout>
                <Part4 />
              </AppLayout>
            </PublicRoute>
          }
        />
      </Routes>
    </>
  );
};

export default MainLayout;
